import { FormControl } from '@mui/material';
import { Select, TopBar } from 'shared-ui';
import styled from 'styled-components';

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;

  padding-bottom: 12px;
`;

export const TopBarWrapper = styled(TopBar)`
  padding-bottom: 12px;
`;

export const RefreshSelectFormControl = styled(FormControl)`
  min-width: 200px;
`;

export const RefreshSelect = styled(Select)`
  width: 200px;
  font-weight: 700;
  padding-top: 22px;
  padding-bottom: 5px;
`;

export const DownloadButtonWrapper = styled.div`
  width: 200px;
  height: 47px;

  & > * {
    width: 100%;
    height: 100%;
  }
`;
